'use client';

import React, { useState } from 'react';
import styled from 'styled-components';
import uniqid from 'uniqid';
import ChevronSvg from '../../assets/ChevronSvg';
const StyledTitleContainer = styled.div.withConfig({
  displayName: "Expander__StyledTitleContainer",
  componentId: "sc-qy4rwk-0"
})(["display:flex;justify-content:center;align-items:center;color:#736b6b;font-family:Roboto,arial,sans-serif;font-size:14px;font-weight:bold;letter-spacing:2px;text-transform:uppercase;margin:0 auto 16px auto;width:fit-content;cursor:", ";"], props => props.$clickable ? 'pointer' : '');
const StyledIconContainer = styled.img.withConfig({
  displayName: "Expander__StyledIconContainer",
  componentId: "sc-qy4rwk-1"
})(["height:24px;margin-right:12px;"]);
const StyledChevronContainer = styled.div.withConfig({
  displayName: "Expander__StyledChevronContainer",
  componentId: "sc-qy4rwk-2"
})(["display:flex;align-items:center;svg{transform:", ";transition:transform 0.3s linear;}"], props => props.$isExpanded ? `rotate(${props.$rotate}deg)` : `rotate(${props.$rotate + 180}deg)`);
const StyledChildrenContainer = styled.div.withConfig({
  displayName: "Expander__StyledChildrenContainer",
  componentId: "sc-qy4rwk-3"
})(["display:flex;opacity:", ";visibility:", ";max-height:", ";transition:opacity 0.3s ease,visibility 0.3s ease,max-height 0.3s ease;flex-wrap:wrap;justify-content:", ";"], props => props.$isExpanded ? '1' : '0', props => props.$isExpanded ? 'visible' : 'hidden', props => props.$isExpanded ? '5000px' : '0px', props => props.$justifyChildren || 'center');
const StyledChildContainer = styled.div.withConfig({
  displayName: "Expander__StyledChildContainer",
  componentId: "sc-qy4rwk-4"
})(["margin-bottom:16px;"]);
const StyledExpanderTextContainer = styled.div.withConfig({
  displayName: "Expander__StyledExpanderTextContainer",
  componentId: "sc-qy4rwk-5"
})(["margin-right:", ";margin-bottom:0;"], props => props.$text ? '16px' : '');
export const Expander = _ref => {
  let {
    title,
    icon,
    iconAlt,
    seeMoreText = 'See More',
    seeLessText = 'See Less',
    pinnedChildren,
    children,
    initialState = 'Default',
    justifyChildren,
    childContainerClassName,
    titleClassName
  } = _ref;
  // if 'Show More' is used (eg. we're only showing some of the children),
  // set expanded to false initially
  const defaultState = !pinnedChildren;
  const [isExpanded, setIsExpanded] = useState(() => {
    if (initialState === 'Default') {
      return defaultState;
    }
    if (initialState === 'Closed') {
      return false;
    }
    return true;
  });
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const expanderText = !isExpanded ? seeMoreText : seeLessText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !pinnedChildren ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTitleContainer, {
    onClick: handleToggle,
    $clickable: true,
    className: titleClassName
  }, icon && /*#__PURE__*/React.createElement(StyledIconContainer, {
    src: icon,
    alt: iconAlt
  }), /*#__PURE__*/React.createElement(StyledExpanderTextContainer, {
    $text: title
  }, title), /*#__PURE__*/React.createElement(StyledChevronContainer, {
    $isExpanded: isExpanded,
    $rotate: 90
  }, /*#__PURE__*/React.createElement(ChevronSvg, null))), /*#__PURE__*/React.createElement(StyledChildrenContainer, {
    $isExpanded: isExpanded,
    $justifyChildren: justifyChildren,
    className: childContainerClassName
  }, children.map(child => /*#__PURE__*/React.createElement(StyledChildContainer, {
    key: uniqid()
  }, child)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTitleContainer, {
    className: titleClassName
  }, icon && /*#__PURE__*/React.createElement(StyledIconContainer, {
    src: icon,
    alt: iconAlt
  }), title), /*#__PURE__*/React.createElement(StyledChildrenContainer, {
    $isExpanded: true,
    $justifyChildren: justifyChildren,
    className: childContainerClassName
  }, children.slice(0, pinnedChildren).map(child => /*#__PURE__*/React.createElement(StyledChildContainer, {
    key: uniqid()
  }, child))), children.length > pinnedChildren ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledChildrenContainer, {
    $isExpanded: isExpanded,
    $justifyChildren: justifyChildren,
    className: childContainerClassName
  }, children.slice(pinnedChildren, children.length).map(child => /*#__PURE__*/React.createElement(StyledChildContainer, {
    key: uniqid()
  }, child))), /*#__PURE__*/React.createElement(StyledTitleContainer, {
    onClick: handleToggle,
    $clickable: true
  }, /*#__PURE__*/React.createElement(StyledExpanderTextContainer, {
    $text: expanderText
  }, expanderText), /*#__PURE__*/React.createElement(StyledChevronContainer, {
    $isExpanded: isExpanded,
    $rotate: 270
  }, /*#__PURE__*/React.createElement(ChevronSvg, null)))) : ''));
};
export default Expander;